export default __webpack_public_path__ + "static/media/disable-popup.2ea17103.svg";